/* eslint-disable no-nested-ternary */
/* eslint-disable-next-line react/no-array-index-key */
import React, { FunctionComponent, useEffect, useState } from 'react';
import { ContentSection } from '@vwfs-bronson/bronson-react';
import { useStepFromUrl } from '../../services/common/miscUtils';
import { useNavigate } from '../../services/routing/navigate';
import { scrollToTop } from '../utils';
import { Step as FormStep1 } from './Step1/index';
import { ProspectPageForm as FormStep2 } from './Step2/index';
import { Step as FormStep3 } from './Step3/index';
import { CustomerDetailsForm as FormStep4 } from './Step4/index';
import { Step as FormStep5 } from './Step5/index';

const StepFormPage = (props: any) => {
  const pathname = window?.location?.pathname;
  const isCoCustomer = pathname.endsWith('coContractor');
  const { step, ...componentProps } = props;

  useEffect(scrollToTop, [step]);

  return (
    <>
      {step === 1 ? (
        <FormStep1 {...componentProps} />
      ) : step === 2 ? (
        <FormStep2 {...componentProps} isCoCustomer={isCoCustomer} />
      ) : step === 3 ? (
        <FormStep3 {...componentProps} />
      ) : step === 4 ? (
        <FormStep4 {...componentProps} isCoCustomer={isCoCustomer} />
      ) : step === 5 ? (
        <FormStep5 {...componentProps} />
      ) : null}
    </>
  );
};

export type BeforeSubmitHandler = (() => Promise<boolean>) | (() => boolean);

export const FormPage: FunctionComponent = () => {
  const [stepOnSubmit, setStepOnSubmit] = useState<BeforeSubmitHandler>(() => () => true);

  const navigate = useNavigate();
  const currentStep = useStepFromUrl();

  useEffect(() => {
    if (!currentStep || currentStep < 1 || currentStep > 5) {
      navigate.root();
    }
  }, [currentStep, navigate]);

  return (
    <ContentSection className="u-pt-none">
      <StepFormPage
        step={currentStep}
        setStepOnSubmit={setStepOnSubmit}
        onSubmit={async () => {
          const shouldRunCommonLogic = await stepOnSubmit();

          if (!shouldRunCommonLogic) return;

          navigate.form(`/${currentStep! + 1}`);
          window.scrollTo(0, 0);
        }}
      />
    </ContentSection>
  );
};
